import dayjs from 'dayjs'

export function getMinDate() {
  const date = new Date()
  date.setMonth(date.getMonth() - 3)
  return date
}

export function sortArrayNumbers(arr) {
  return arr.sort((a, b) => parseFloat(a) - parseFloat(b))
}

export function getCountrySchema(countryId) {
  switch (countryId) {
  case 1: // Chile
    return [
      { label: 'Región', key: 'region', class: ['text-center'] },
      { label: 'Comuna', key: 'comuna', class: ['text-center'] },
      { label: 'Tiempo de tránsito', key: 'transit_days', class: ['text-center'] }
    ]
  case 3: // Colombia
    return [
      { label: 'Código', key: 'codigo', class: ['text-center'] },
      { label: 'Departamento', key: 'departamento', class: ['text-center'] },
      { label: 'Municipio', key: 'municipio', class: ['text-center'] },
      { label: 'Flete de manejo mínimo', key: 'freight_minimum_cost', class: ['text-center'] },
      { label: '% flete de manejo', key: 'freight_percentage_cost', class: ['text-center'] },
      { label: 'Tiempo de tránsito', key: 'transit_days', class: ['text-center'] }
    ]
  case 2: // México
    return [
      { label: 'CP', key: 'cp', class: ['text-center'] },
      { label: 'Estado', key: 'estado', class: ['text-center'] },
      { label: 'Municipio', key: 'municipio', class: ['text-center'] },
      { label: 'Tiempo de tránsito', key: 'transit_days', class: ['text-center'] }
    ]
  case 4: // Perú
    return [
      { label: 'Ubigeo', key: 'ubigeo', class: ['text-center'] },
      { label: 'Departamento', key: 'departamento', class: ['text-center'] },
      { label: 'Provincia', key: 'provincia', class: ['text-center'] },
      { label: 'Distrito', key: 'distrito', class: ['text-center'] },
      { label: 'Tiempo de tránsito', key: 'transit_days', class: ['text-center'] }
    ]
  default:
    return []
  }
}

export function getWeightSchema(max = 6) {
  const schema = []
  for (let i = 1; i <= max; i++) {
    schema.push({ label: `Precio (${i}kg)`, key: `price_${i}`, class: ['text-center'] })
  }
  return schema
}

export function formatDate_YYYY_MM_DD(date) {
  return dayjs(date).format('YYYY-MM-DD')
}

export async function setPlaces({ value, form, baseService }) {
  const params = { country_id: form.country.id }
  const queryParams = { search: value }

  try {
    const resp = await baseService.callService('getPlacesFullLevelSearchByCountry', queryParams, params)
    return resp.data.places.map((el) => ({
      ...el,
      text: el.full_name,
      valid: true
    }))
  } catch (err) {
    return err
  }
}

// pricing.helpers.js
export function buildSchemaByCountry(countryId, arrayCurrentKgs) {
  const schema = [
    { label: 'Tiempo de tránsito', key: 'transit_days', class: ['text-center'] }
  ]
  arrayCurrentKgs.forEach(el => {
    schema.push({
      label: `Precio (${el}kg)`,
      key: `${el}kg`,
      class: ['text-right']
    })
  })
  if (countryId === 1) {
    schema.unshift({ label: 'Comuna', key: 'level0' })
    schema.unshift({ label: 'Región', key: 'level2' })
  } else if (countryId === 3) {
    schema.unshift({ label: 'Municipio', key: 'level0' })
    schema.unshift({ label: 'Departamento', key: 'level2' })
    schema.unshift({ label: 'Código', key: 'dest_place_code' })
  } else if (countryId === 4) {
    schema.unshift({ label: 'Distrito', key: 'level1' })
    schema.unshift({ label: 'Provincia', key: 'level2' })
    schema.unshift({ label: 'Departamento', key: 'level3' })
    schema.unshift({ label: 'Ubigeo', key: 'level0' })
  } else if (countryId === 2) {
    schema.unshift({ label: 'Municipio', key: 'level1' })
    schema.unshift({ label: 'Estado', key: 'level2' })
    schema.unshift({ label: 'CP', key: 'level0' })
  }
  return schema
}